import { useEffect } from 'react';
import { selectFormattedFiltersForGTM } from '../../../core/reducers/vehicleListFilters';
import { useAppSelector } from '../../../core/utils';
import { removeMarkdown } from '../../../utils/markdown';
import gtmFilterSelectionList from '../../../core/gtm/gtmFilterSelectionList';
const useFilterGtm = () => {
    const formattedFilterSelectionList = removeMarkdown(useAppSelector(selectFormattedFiltersForGTM));
    useEffect(() => {
        if (formattedFilterSelectionList) {
            gtmFilterSelectionList(formattedFilterSelectionList);
        }
    }, [formattedFilterSelectionList]);
};
export default useFilterGtm;
